<template>
  <v-text-field
    v-bind="{...defaults, ...$attrs}"
    class="ol-text-field"
    outlined
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <slot />
  </v-text-field>
</template>

<script>
export default {
  name: 'OlTextField',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {
      filled: true,
      'background-color': 'white'
    }
  }
}
</script>

<style lang="scss">

.ol-text-field, .ol-autocomplete, .ol-combobox, .ol-textarea {

  &.v-text-field--filled {
    border-radius: 8px;
  }

  &.v-text-field--filled .v-text-field__slot,
  &.v-text-field--filled .v-select__slot {
    background-color: transparent;
  }

  &.v-text-field--filled .v-text-field__slot::after,
  &.v-text-field--filled .v-text-field__slot::before,
  &.v-text-field--filled .v-select__slot::after,
  &.v-text-field--filled .v-select__slot::before {
    display: none;
  }

  &.v-text-field--filled > .v-input__control > .v-input__slot:before/* ,
  &.v-text-field--filled > .v-input__control .v-select__slot:before */ {
    border-style: none;
  }

  label {
    text-transform: uppercase;
  }

}
</style>
